import {
    CONFIRMED_GET_KARMAS,
    CONFIRMED_CREATE_KARMA_ACTION,
    CONFIRMED_EDIT_KARMA_ACTION,
    CONFIRMED_DELETE_KARMA_ACTION,
  } from "../actions/KarmaType"
  
  const initialState = {
    karmas: [],
    num_rows: 0,
  }
  
  export default function KarmaReducer(state = initialState, action) {
    if (action.type === CONFIRMED_GET_KARMAS) {
      return {
        ...state,
        karmas: action.payload.karmas || [],
        num_rows: action.payload.num_rows || 0,
      }
    }
  
    if (action.type === CONFIRMED_CREATE_KARMA_ACTION) {
      if (!action.payload) return state // safeguard
      return {
        ...state,
        karmas: [...state.karmas, action.payload],
      }
    }
    
    if (action.type === CONFIRMED_EDIT_KARMA_ACTION) {
      if (!action.payload) return state // ✅ prevent undefined crash
    
      const updatedId = action.payload.id ?? action.payload.karma_id
      if (!updatedId) return state // ✅ handle missing id
    
      return {
        ...state,
        karmas: state.karmas.map((k) =>
          (k.id ?? k.karma_id) === updatedId ? { ...k, ...action.payload } : k
        ),
      }
    }
    
  
    if (action.type === CONFIRMED_DELETE_KARMA_ACTION) {
      const delId = action.payload.karma_id
      return {
        ...state,
        karmas: state.karmas.filter((k) => (k.id ?? k.karma_id) !== delId),
      }
    }
  
    return state
  }
  